export default __webpack_public_path__ + "static/media/scalableNodeApis.33031a70.md";